"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DittoLazyProvider = void 0;
var ditto_1 = require("@dittolive/ditto");
var react_1 = __importStar(require("react"));
var DittoContext_1 = require("./DittoContext");
var DittoLazyProvider = function (_a) {
    var initOptions = _a.initOptions, setup = _a.setup, render = _a.render, children = _a.children;
    var _b = (0, react_1.useState)({}), dittoHash = _b[0], setDittoHash = _b[1];
    var createdPaths = (0, react_1.useRef)([]);
    var _c = (0, react_1.useState)({
        loading: true,
        error: undefined,
    }), providerState = _c[0], setProviderState = _c[1];
    var hasMountEffectStarted = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (hasMountEffectStarted.current) {
            return;
        }
        ;
        (function () {
            return __awaiter(this, void 0, void 0, function () {
                var err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            hasMountEffectStarted.current = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, (0, ditto_1.init)(initOptions)];
                        case 2:
                            _a.sent();
                            setProviderState({
                                error: undefined,
                                loading: false,
                            });
                            return [3, 4];
                        case 3:
                            err_1 = _a.sent();
                            setProviderState({
                                error: err_1 instanceof Error ? err_1 : undefined,
                                loading: false,
                            });
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        })();
    }, []);
    var renderFunction = render || children;
    var child = react_1.default.createElement(react_1.default.Fragment, null);
    if (renderFunction) {
        child = renderFunction(providerState);
    }
    var handleLoadInstance = function (appPath) { return __awaiter(void 0, void 0, void 0, function () {
        var dittoInstance_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!createdPaths.current.includes(appPath)) return [3, 1];
                    return [2, dittoHash[appPath] || null];
                case 1:
                    createdPaths.current.push(appPath);
                    setDittoHash(function (currentHash) {
                        var _a;
                        return (__assign(__assign({}, currentHash), (_a = {}, _a[appPath] = null, _a)));
                    });
                    return [4, setup(appPath)];
                case 2:
                    dittoInstance_1 = _a.sent();
                    if (dittoInstance_1) {
                        setDittoHash(function (currentHash) {
                            var _a;
                            return (__assign(__assign({}, currentHash), (_a = {}, _a[appPath] = dittoInstance_1, _a)));
                        });
                    }
                    return [2, dittoInstance_1];
            }
        });
    }); };
    var registerDitto = function (ditto) {
        if (ditto.persistenceDirectory in dittoHash) {
            throw new Error('The instance path is already being used by a Ditto instance.');
        }
        setDittoHash(function (currentHash) {
            var _a;
            return (__assign(__assign({}, currentHash), (_a = {}, _a[ditto.persistenceDirectory] = ditto, _a)));
        });
    };
    var unregisterDitto = function (path) {
        var hash = __assign({}, dittoHash);
        delete hash[path];
        setDittoHash(hash);
    };
    return (react_1.default.createElement(DittoContext_1.DittoContext.Provider, { value: {
            dittoHash: dittoHash,
            registerDitto: registerDitto,
            unregisterDitto: unregisterDitto,
            load: handleLoadInstance,
            isLazy: true,
        } }, child));
};
exports.DittoLazyProvider = DittoLazyProvider;
//# sourceMappingURL=DittoLazyProvider.js.map